import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type ParameterID, type CoreBookingService } from '@flecto/types'
import {
  DataTable,
  type DataTableColumn,
  type DataTableProps,
  TextCurrency,
} from '@flecto/ui'

import { useTaxesInfo } from '../../../taxes'
import { CellActions } from './CellActions'

export type TableBookingServicesProps = Omit<
  DataTableProps<CoreBookingService[]>,
  'columns'
> & {
  bookingId?: ParameterID
  bookingServices?: CoreBookingService[]
}

export function TableBookingServices({
  bookingId,
  bookingServices,
  ...props
}: TableBookingServicesProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_services' })

  const {  userSettingShowPricesWithTaxes } =
    useTaxesInfo()

  const columns: DataTableColumn<CoreBookingService>[] = [
    {
      accessor: 'service_kind',
      title: t('label_service'),
      width: 250,
      render: (row) => (
        <Text fw={500}>{t(`service_kind.${row.service_kind}`)}</Text>
      ),
    },
    {
      accessor: 'price',
      title: t('label_price'),
      textAlign: 'left',
      render: (row) => {

        return (
          <TextCurrency
            cents={
              userSettingShowPricesWithTaxes
                ? row.meta?.price_with_vat_cents
                : row.price_cents
            }
          />
        )
      },
    },
    {
      accessor: 'actions',
      title: '',
      width: 100,
      textAlign: 'right',
      render: (row) => (
        <CellActions bookingService={row} bookingId={bookingId} />
      ),
    },
  ]

  return (
    // @ts-expect-error page prop can be undefined
    <DataTable {...props} records={bookingServices} columns={columns} />
  )
}
